/** Privy 前端配置（App ID / Client ID 来自 env；App Secret、Signer Key 仅在后端） */

function trim(v) {
  return String(v ?? '').trim();
}

export const privyConfig = {
  /** DeepSage Privy App ID */
  appId: trim(process.env.VUE_APP_PRIVY_APP_ID),
  /** Dashboard → App settings → Clients（Web 可留空，SDK 仍可用 App ID 初始化） */
  clientId: trim(process.env.VUE_APP_PRIVY_CLIENT_ID),
  /** OAuth 回跳 origin，留空则用 window.location.origin */
  appOrigin: trim(process.env.VUE_APP_APP_ORIGIN),
  /** Dashboard → Authorization keys → Signer ID（DeepSageKey） */
  signerKeyId: trim(process.env.VUE_APP_PRIVY_SIGNER_KEY_ID),
};

export function isPrivyConfigured() {
  return Boolean(privyConfig.appId);
}

export function resolvePrivyAppOrigin() {
  if (privyConfig.appOrigin) return privyConfig.appOrigin.replace(/\/$/, '');
  if (typeof window !== 'undefined') return window.location.origin;
  return '';
}
